import InfinityList, {
  InfinityListProps,
} from '@/components/ui/custom/InfinityList';
import PromptInstruction from '@/models/PromptInstruction';
import PromptsTreeItem from './items/PromptsTreeItem';

export type PromptsTreeListProps = {
  items: PromptInstruction[];
  isRoot?: boolean;
  isLoading?: boolean;
  fetchNextPage: () => void;
} & Pick<InfinityListProps, 'hasNextPage' | 'isFetchingNextPage'>;

export default function PromptsTreeList({
  items,
  isRoot,
  fetchNextPage,
  isLoading,
  ...infinityListProps
}: PromptsTreeListProps) {
  return (
    <InfinityList
      className={`flex flex-col gap-2 pt-2 ${!isRoot && 'ml-5'}`}
      hasNextPage={infinityListProps.hasNextPage}
      isFetchingNextPage={infinityListProps.isFetchingNextPage}
      onReachEnd={fetchNextPage}
    >
      {items.map(prompt => (
        <PromptsTreeItem key={prompt.id} prompt={prompt} />
      ))}
    </InfinityList>
  );
}
